<template>
  <div>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :title="(isEditWorkFlow ? 'Update ' : isDuplicateWorkFlow ? 'Duplicate ' : 'Add New ') + ' Workflow Setting'"
      size="xl"
      scrollable
      v-model="showAddModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-tabs
            small
            card
            fill
          >
            <b-tab
              title="Setup"
              class="text-left"
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Title"
                    description="Please enter a title"
                  >
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="$v.form.title.$model"
                      :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
                      @input="setTitleValue"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Version"
                    description="Please enter a version"
                  >
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="$v.form.version.$model"
                      :state="$v.form.version.$dirty ? !$v.form.version.$error : null"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.title">
                <b-col cols="6">
                  <b-form-group label="Complaints Types">
                    <b-form-checkbox
                      inline
                      v-model="selectedComplaintsType"
                      v-for="(type,index) in complaintTypesOptions"
                      :key="index"
                      :value="type"
                      @input="setComplaintTypesTabs"
                    >{{type.text}}</b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group>
                    <b-form-checkbox
                      inline
                      v-model="selectedLanguage"
                      v-for="(language,index) in languagesOptions"
                      :key="index"
                      :value="language"
                      :disabled="language.text == 'English' ? true : false"
                      @input="setNewLanguageEmail"
                    >{{language.text}}</b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              :title="tab.text"
              v-for="(tab,tabIndex) in selectedComplaintsType"
              :key="tabIndex"
              @click="setEmailLanguages(tabIndex)"
              lazy
            >
              <AddModalComponents
                :complaintTypeIndex="tabIndex"
                :selectedLanguage="selectedLanguage"
                :emailTagsOptions="emailTagsOptions"
                :platformSettingOptions="platformSettingOptions"
                :selectedLanguageLength="selectedLanguageLength"
              />
            </b-tab>
          </b-tabs>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ isEditWorkFlow ? 'Your Workflow is being Updating......' : isDuplicateWorkFlow ? 'Your Workflow is being duplicating......' : 'Your Workflow is being Creating......'}}</p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ isEditWorkFlow ? 'Your Workflow has been updated successfully.' : isDuplicateWorkFlow ? 'Your Workflow has been Duplicated successfully.' : 'Your Workflow has been added successfully.'}}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          @click="closeModal"
          variant="outline-danger"
        >Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{ isEditWorkFlow ? 'Update' : isDuplicateWorkFlow ? 'Duplicate' : 'Save '}}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../../../../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import AddModalComponents from "./modalComponents/addModalComponents.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AddNewComplaintSettingModal",
  mixins: [validationMixin],
  components: {
    AddModalComponents,
  },
  data () {
    return {
      submiting: false,
      responseSuccess: false,
      isLoading: false,
      showAddModal: false,
      selectedComplaintsType: [],
      complaintTypesOptions: [],
      emailTagsOptions: [],
      platformSettingOptions: [],
      form: {
        title: null,
        version: null,
      },
      workflowSettingId: null,
      isEditWorkFlow: false,
      languagesOptions: [],
      editConfigrationData: [],
      isDuplicateWorkFlow: false,
      selectedLanguage: [{ text: "English", value: "1" }],
      selectedLanguageLength: null,
      setupEmails: {}
      // showSelect: []
    };
  },
  validations: {
    form: {
      title: { required },
      version: { required },
    },
  },
  created () {
    EventBus.$on( "onShowAddComplaintSettingsModal", () => {
      this.showAddComplaintSettingModal();
    } );
    EventBus.$on( "onShowEditComplaintSettingsModal", ( value ) => {
      this.showEditComplaintSettingModal( value );
    } );
    EventBus.$on( "onShowDuplicateComplaintWorkflowSettingModal", ( value ) => {
      this.showDuplicateWorkflowModal( value );
    } );
  },
  mounted () {
    this.getEmployeeLanguages();
    this.getComplaintTypesList();
    this.getEmailTagsList();
    this.getPlatformSettingList();
  },
  methods: {
    setNewLanguageEmail () {
      // in this function in hasOwnProperty if condition we check that language value object already exist or not if exist then we take emails subject and message as per that language from settings and assign that value

      // or in else condition if we don't have that language object then we add that new language object

      this.$store.state.complaintSettingsWorkFlowCategories.map( settings => {
        this.setupEmails = {};
        if ( this.selectedLanguageLength != this.selectedLanguage.length && settings.emails != null ) {
          this.selectedLanguage.map( ( languages ) => {
            let language = languages.value;
            if ( settings.emails.hasOwnProperty( language ) ) {
              this.setupEmails[language] = {
                newComplaintRequestToApprover: {
                  subject: settings.emails[language].newComplaintRequestToApprover.subject,
                  message: settings.emails[language].newComplaintRequestToApprover.message,
                },
                completedEmail: {
                  subject: settings.emails[language].completedEmail.subject,
                  message: settings.emails[language].completedEmail.message,
                },
                onHoldEmail: {
                  subject: settings.emails[language].onHoldEmail.subject,
                  message: settings.emails[language].onHoldEmail.message,
                },
                newComplaintRequestEmail: {
                  subject: settings.emails[language].newComplaintRequestEmail.subject,
                  message: settings.emails[language].newComplaintRequestEmail.message,
                },
              }
            } else {
              this.setupEmails[language] = {
                newComplaintRequestToApprover: {
                  subject: null,
                  message: null,
                },
                completedEmail: {
                  subject: null,
                  message: null,
                },
                onHoldEmail: {
                  subject: null,
                  message: null,
                },
                newComplaintRequestEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.emails = this.setupEmails;
            }
          } );
        }
      } );
    },
    setEmailLanguages ( tabIndex ) {
      // in this we check that every object got emails object as per selected language if somehow emails object is null then we asign object in this function when that type tab open
      if ( this.$store.state.complaintSettingsWorkFlowCategories[tabIndex].emails == null ) {
        this.selectedLanguageLength = this.selectedLanguage.length;
        this.selectedLanguage.map( ( languages ) => {
          let language = languages.value;
          this.setupEmails[language] = {
            newComplaintRequestToApprover: {
              subject: null,
              message: null,
            },
            completedEmail: {
              subject: null,
              message: null,
            },
            onHoldEmail: {
              subject: null,
              message: null,
            },
            newComplaintRequestEmail: {
              subject: null,
              message: null,
            },
          };
          this.$store.state.complaintSettingsWorkFlowCategories[tabIndex].emails = this.setupEmails;
        } );
      }
    },
    showDuplicateWorkflowModal ( value ) {
      this.isDuplicateWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      this.editConfigrationData = [];
      this.$store.state.complaintSettingsWorkFlowCategories = [];
      if ( configurationData.selectedComplaintsType.length > 0 ) {
        configurationData.selectedComplaintsType.map( ( types ) => {
          this.selectedComplaintsType.push( types );
        } );
      }
      if ( configurationData.languages.length > 0 ) {
        this.selectedLanguage = [];
        this.selectedLanguageLength = null;
        this.selectedLanguageLength = configurationData.languages.length;
        configurationData.languages.map( ( language ) => {
          this.selectedLanguage.push( language );
        } );
      }
      if ( configurationData.categories.length > 0 ) {
        configurationData.categories.map( ( categorieData ) => {
          this.editConfigrationData.push( categorieData.settings );
        } );
        this.editConfigrationData.map( ( data ) => {
          this.$store.state.complaintSettingsWorkFlowCategories.push( data );
        } );
        this.setNewEmailObject();
      }
      this.showAddModal = true;
    },
    showEditComplaintSettingModal ( value ) {
      this.isEditWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      this.editConfigrationData = [];
      this.$store.state.complaintSettingsWorkFlowCategories = [];
      if ( configurationData.selectedComplaintsType.length > 0 ) {
        configurationData.selectedComplaintsType.map( ( types ) => {
          this.selectedComplaintsType.push( types );
        } );
      }
      if ( configurationData.languages.length > 0 ) {
        this.selectedLanguage = [];
        this.selectedLanguageLength = null;
        this.selectedLanguageLength = configurationData.languages.length;
        configurationData.languages.map( ( language ) => {
          this.selectedLanguage.push( language );
        } );
      }
      if ( configurationData.categories.length > 0 ) {
        configurationData.categories.map( ( categorieData ) => {
          this.editConfigrationData.push( categorieData.settings );
        } );
        this.editConfigrationData.map( ( data ) => {
          this.$store.state.complaintSettingsWorkFlowCategories.push( data );
        } );
        this.setNewEmailObject();
      }
      this.showAddModal = true;
    },
    setNewEmailObject () {
      // this function is created to create new email object like if in future we need to add one more email type then we have to check hasOwnProperty condtion so if we add new object then on edit or duplication our application don't stuck.

      // first in hasOwnProperty we check that that type email exist if yes then nothing else we asign that email type object in emails language object
      this.selectedLanguage.map( languages => {
        let languageValue = languages.value;
        this.$store.state.complaintSettingsWorkFlowCategories.map( categories => {
          if ( categories.emails[languageValue].hasOwnProperty( "newComplaintRequestToApprover" ) ) {
          } else {
            let newComplaintRequestToApprover = {
              subject: null,
              message: null,
            }
            Object.assign( categories.emails[languageValue], { newComplaintRequestToApprover } );
          }
          if ( categories.emails[languageValue].hasOwnProperty( "completedEmail" ) ) {
          } else {
            let completedEmail = {
              subject: null,
              message: null,
            }
            Object.assign( categories.emails[languageValue], { completedEmail } );
          }
          if ( categories.emails[languageValue].hasOwnProperty( "onHoldEmail" ) ) {
          } else {
            let onHoldEmail = {
              subject: null,
              message: null,
            }
            Object.assign( categories.emails[languageValue], { onHoldEmail } );
          }
          if ( categories.emails[languageValue].hasOwnProperty( "newComplaintRequestEmail" ) ) {
          } else {
            let newComplaintRequestEmail = {
              subject: null,
              message: null,
            }
            Object.assign( categories.emails[languageValue], { newComplaintRequestEmail } );
          }
        } )
      } );
    },
    setComplaintTypesTabs () {
      this.selectedComplaintsType.map( () => {
        this.setComplaintTypesValue();
      } );
    },
    setComplaintTypesValue () {
      this.$store.state.complaintSettingsWorkFlowCategories.push( {
        configration: {
          showApprovers: false,
          showEmail: false,
          emailTags: this.emailTagsOptions,
          platformSettings: this.platformSettingOptions,
        },
        approvers: {
          approversList: [],
        },
        emails: null,
      } );
      this.setNewTabEmail();
    },
    setNewTabEmail () {
      // this function works when we select or deselected approval type so to add selected language objects in emails in selected approval types objects confiugration
      this.$store.state.complaintSettingsWorkFlowCategories.map( settings => {
        if ( settings.emails == null ) {
          this.setupEmails = {};
          this.selectedLanguage.map( ( languages ) => {
            let language = languages.value;
            this.setupEmails[language] = {
              newComplaintRequestToApprover: {
                subject: null,
                message: null,
              },
              completedEmail: {
                subject: null,
                message: null,
              },
              onHoldEmail: {
                subject: null,
                message: null,
              },
              newComplaintRequestEmail: {
                subject: null,
                message: null,
              },
            };
            settings.emails = this.setupEmails;
          } );
        }
      } );
    },
    async getEmployeeLanguages () {
      this.languagesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languagesOptions = result.data.employeeLanuages;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getComplaintTypesList () {
      this.complaintTypesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/complaints/type", null );
        this.complaintTypesOptions = result.data.complaintType;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmailTagsList () {
      this.emailTagsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/tag/list", null );
        this.emailTagsOptions = result.data.emailTags;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getPlatformSettingList () {
      this.platformSettingOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/platform/list", null );
        if ( result.data[0].platform_variables ) {
          let settings = JSON.parse( result.data[0].platform_variables );
          this.platformSettingOptions = settings;
        }
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    showAddComplaintSettingModal () {
      this.showAddModal = true;
    },
    setTitleValue ( value ) {
      if ( value ) {
        return "";
      } else if ( value == null ) {
        this.selectedComplaintsType = [];
        this.selectedLanguage = [];
        this.$store.state.complaintSettingsWorkFlowCategories = [];
      }
    },
    closeModal () {
      this.showAddModal = false;
      this.editConfigrationData = [];
      this.workflowSettingId = null;
      this.isEditWorkFlow = false;
      this.isDuplicateWorkFlow = false;
      this.selectedComplaintsType = [];
      this.form = {
        title: null,
        version: null,
      };
      this.selectedLanguage = [{ text: "English", value: "1" }];
      this.$store.state.complaintSettingsWorkFlowCategories = [];
      this.selectedLanguageLength = null;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "complaints-table" );
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else if ( this.isEditWorkFlow ) {
        this.updateComplaintSetting().then( this.reloadTable );
      } else {
        this.saveComplaintSettings().then( this.reloadTable );
      }
    },
    async updateComplaintSetting () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        workflow_setting_id: this.workflowSettingId,
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 3,
        configuration: {
          selectedComplaintsType: this.selectedComplaintsType,
          languages: this.selectedLanguage,
          categories: this.selectedComplaintsType.map( ( types, index ) => {
            return {
              title: types.text,
              id: types.value,
              settings: this.$store.state.complaintSettingsWorkFlowCategories[
                index
              ],
            };
          } ),
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/update", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async saveComplaintSettings () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 3,
        configuration: {
          selectedComplaintsType: this.selectedComplaintsType,
          languages: this.selectedLanguage,
          categories: this.selectedComplaintsType.map( ( types, index ) => {
            return {
              title: types.text,
              id: types.value,
              settings: this.$store.state.complaintSettingsWorkFlowCategories[
                index
              ],
            };
          } ),
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/create", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
  },
};
</script>